<template>
  <v-card elevation="0" flat color="bglight" class="mb-7">
    <v-tabs height="80" color="third" :value="getTabs.main" @change="setTab" grow>
      <v-tab v-for='mainTab in mainTabs' :key="mainTab.value" :href="`#${mainTab.value}`"
        :disabled="isDisabled(mainTab)">
        {{ mainTab.name }}
      </v-tab>
    </v-tabs>
    <v-dialog v-model="notAllowedDialog" max-width="520" persistent>
      <v-card>
        <v-card-title class="text-h6">
          You must complete previous forms to continue
        </v-card-title>

        <v-card-text>
          {{ notAllowedReason }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="third" text @click="closeNotAllowedDialog">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MainTab',
  data() {
    return {
      notAllowedDialog: false,
      notAllowedReason: '',
    };
  },
  computed: {
    ...mapGetters(['isReady', 'getGlobalLoadStatus', 'mainTabs', 'getTabs', 'canGoToTab']),
  },
  methods: {
    ...mapActions(['setMainTab', 'setReadyToSignStatus']),
    isTabAllowed(tabId) {
      const permission = this.canGoToTab(tabId);
      return { ok: Boolean(permission?.status), reason: permission?.reason };
    },
    setTab(e) {
      if (e !== 'signAndSubmit') {
        this.setReadyToSignStatus(false);
      }

      const { ok, reason } = this.isTabAllowed(e);
      if (ok) {
        this.setMainTab(e);
      } else {
        this.showNotAllowedReason(reason);
      }
    },
    isDisabled(tab) {
      if (this.getGlobalLoadStatus) {
        return true;
      }
      if (tab.value === 'signAndSubmit') {
        if (this.isReady) {
          return false;
        }
        return true;
      }
      return false;
    },
    showNotAllowedReason(reason) {
      this.notAllowedReason = reason || 'This tab is not available right now.';
      this.notAllowedDialog = true;
    },
    closeNotAllowedDialog() {
      this.notAllowedDialog = false;
      this.notAllowedReason = '';
    },
  },
};
</script>
